"use client";

import Script from "next/script";
import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";
import { analyticsEnabled, getAnalyticsEnv } from "../lib/env";
import { flushMetaEvents, trackMetaPageView } from "../lib/analytics";

type Props = {
  externalId?: string;
  autoConfig?: boolean;
};

export function MetaPixel({ externalId, autoConfig = false }: Props) {
  const { metaPixelId } = getAnalyticsEnv();
  const pathname = usePathname();
  const initialPathTracked = useRef(false);

  useEffect(() => {
    if (typeof window.fbq === "function") window.fbq("consent", "grant");
  }, []);

  useEffect(() => {
    if (!initialPathTracked.current) {
      initialPathTracked.current = true;
      return;
    }
    trackMetaPageView();
  }, [pathname]);

  if (!analyticsEnabled || !metaPixelId) return null;

  const id = JSON.stringify(metaPixelId);
  const init = externalId
    ? `${id},${JSON.stringify({ external_id: externalId })}`
    : id;
  const disableAutoConfig = autoConfig ? "" : `fbq('set','autoConfig',false,${id});`;

  return (
    <Script id="meta-pixel" strategy="afterInteractive" onReady={flushMetaEvents}>
      {`!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');${disableAutoConfig}fbq('init',${init});fbq('track','PageView');`}
    </Script>
  );
}

export function MetaPixelOff() {
  useEffect(() => {
    if (typeof window.fbq === "function") window.fbq("consent", "revoke");
  }, []);

  return null;
}
